export default {
  state: {
   formulaConsolidation : {},
  },

  getters: {
    getformulaConsolidationData(state) {
      return state.formulaConsolidation;
    },
  },

  mutations: {
   setformulaConsolidationData(state, data) {
      const isNull = data === null;

      state.formulaConsolidation = {
        id: !isNull ? data.id : 0,
        balanceCurrentMonth: !isNull ? data.balanceCurrentMonth : 0,
        entryCurrentMonth: !isNull ? data.entryCurrentMonth : 0,
        totalNumberChildrenServed: !isNull ? data.totalNumberChildrenServed : 0,
        totalNumberChildrenExposed: !isNull ? data.totalNumberChildrenExposed : 0,
        cansQuantity: !isNull ? data.cansQuantity : 0,
        dispensedCans: !isNull ? data.dispensedCans : 0,
        formulaTypeId: !isNull ? data.formulaTypeId : 0,
      };
    },
  },

  actions: {
   changeformulaConsolidationData(context, infos) {
      context.commit("setformulaConsolidationData", infos);
    },
  },
};
